import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Nav() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const links = [{
    href: '#coming-soon',
    label: "What's Coming"
  }, {
    href: '#contact',
    label: 'Contact'
  }];
  return <header id="top" className="sticky top-3 sm:top-4 z-50 px-3 sm:px-5" data-id="element-145">
      <div className={`nav-pill max-w-6xl mx-auto px-5 sm:px-7 h-16 flex items-center justify-between transition-colors duration-300 ${scrolled ? 'is-scrolled' : ''}`} data-id="element-146">
        <a href="#top" className="flex items-center" aria-label="AFEXA — Africa Commodity Exchange home" data-id="element-147">
          <img src="https://cdn.magicpatterns.com/uploads/g6ebYu1Xjz1ZLZcTiKmQS5/background-removed.png" alt="AFEXA — Africa Commodity Exchange" className={`h-11 w-auto transition-[filter] duration-300 ${scrolled ? 'brightness-0 invert' : ''}`} data-id="element-148" />
        </a>

        <nav className={`hidden lg:flex items-center gap-7 text-sm font-medium transition-colors duration-300 ${scrolled ? 'text-paper/85' : 'text-forest/80'}`} data-id="element-149">
          {links.map(link => <a key={link.href} href={link.href} className={`transition-colors ${scrolled ? 'hover:text-goldlight' : 'hover:text-leaf'}`} data-id="element-150">
              {link.label}
            </a>)}
        </nav>

        <div className="flex items-center gap-3" data-id="element-151">
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'} aria-expanded={mobileMenuOpen} className={`lg:hidden p-2 transition-colors duration-300 ${scrolled ? 'text-paper' : 'text-forest'}`} data-id="element-152">
            {mobileMenuOpen ? <XIcon className="h-6 w-6" strokeWidth={1.8} data-id="element-153" /> : <MenuIcon className="h-6 w-6" strokeWidth={1.8} data-id="element-154" />}
          </button>
        </div>
      </div>

      {mobileMenuOpen && <div className={`lg:hidden mt-2 max-w-6xl mx-auto rounded-3xl shadow-xl overflow-hidden px-3 py-3 flex flex-col font-medium transition-colors duration-300 ${scrolled ? 'bg-forestdeep/95 backdrop-blur' : 'bg-white/95 backdrop-blur'}`} data-id="element-155">
          {links.map(link => <a key={link.href} href={link.href} onClick={() => setMobileMenuOpen(false)} className={`rounded-2xl px-4 py-3 text-base transition-colors ${scrolled ? 'text-paper/90 hover:bg-white/10 hover:text-goldlight' : 'text-forest/90 hover:bg-paperdeep hover:text-leaf'}`} data-id="element-156">
              {link.label}
            </a>)}
        </div>}
    </header>;
}